"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const react_use_1 = require("react-use");
const react_device_detect_1 = require("react-device-detect");
const uuid_1 = require("uuid");
const noop_1 = __importDefault(require("lodash/noop"));
const styles_1 = require("@mui/material/styles");
const Box_1 = __importDefault(require("@mui/material/Box"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const ExpandMoreRounded_1 = __importDefault(require("@mui/icons-material/ExpandMoreRounded"));
const ExpandLessRounded_1 = __importDefault(require("@mui/icons-material/ExpandLessRounded"));
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const core_1 = require("companion-app-components/utils/core");
const accounts_1 = require("companion-app-components/flux/accounts");
const categories_1 = require("companion-app-components/flux/categories");
const chart_of_accounts_1 = require("companion-app-components/flux/chart-of-accounts");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const auth_1 = require("companion-app-components/flux/auth");
const selectors_1 = require("data/transactions/selectors");
const NestedQMenu_1 = __importDefault(require("components/NestedQMenu"));
const QTip_1 = __importDefault(require("components/QuickenControls/QTip"));
const QIconButton_1 = __importDefault(require("components/QIconButton"));
const QTypography_1 = __importDefault(require("components/MUIWrappers/QTypography"));
const utils_1 = require("components/TransactionRegister/utils");
const utils_2 = require("utils/utils");
const helpers_1 = require("../helpers");
const log = (0, core_1.getLogger)('components/QuickenControls/CategoryFieldEditable/index.js');
// eslint-disable-next-line @typescript-eslint/no-var-requires
const isIe = require('is-iexplorer');
const inputHeight = isIe ? 27 : 24;
const NONE_COA_NODE = {
    id: 'NONE',
    coa: { type: 'NONE', id: '0' },
    name: '- None -',
    fullPathName: '- None -',
    inList: true,
};
const CategoryFieldEditable = (props) => {
    var _a;
    const theme = (0, styles_1.useTheme)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const coaTreeNormal = (0, react_redux_1.useSelector)((state) => chart_of_accounts_1.chartOfAccountsSelectors.getChartOfAccountsTree(state, props));
    const coaTreeTransfer = (0, react_redux_1.useSelector)((state) => chart_of_accounts_1.chartOfAccountsSelectors.getTransferCOATree(state));
    const coaTree = props.transferOnly ? coaTreeTransfer : coaTreeNormal;
    const categoriesById = (0, react_redux_1.useSelector)((state) => categories_1.categoriesSelectors.getCategoriesById(state));
    const isAccountGroupEnabledUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isAccountGroupEnabled);
    const allAccountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getAccountsById(state));
    const entitySharedAccountsById = (0, react_redux_1.useSelector)((state) => accounts_1.accountsSelectors.getEntityShareAccountsById(state));
    const accountsById = isAccountGroupEnabledUser ? entitySharedAccountsById : allAccountsById;
    const popularCats = (0, react_redux_1.useSelector)((state) => (0, selectors_1.getMostPopularCatsByAccountId)(state));
    const isEntitySharedUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const currentDataset = (0, react_redux_1.useSelector)(auth_1.authSelectors.getCurrentDataset);
    const accountGroups = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.getAccountGroups);
    const getCoaNode = (0, react_1.useCallback)((coaId) => {
        let ret = props.coaNodesById ? props.coaNodesById.get(coaId) : null;
        if (!ret && coaId === 'NONE') {
            return NONE_COA_NODE;
        }
        if (props.value && props.coaNodesById && chart_of_accounts_1.chartOfAccountsUtils.isTransferCoaNotFound(props.value)) {
            ret = props.coaNodesById.get(chart_of_accounts_1.chartOfAccountsUtils.TRANSFER_NOT_FOUND_COA_ID);
        }
        return ret;
    }, [props.coaNodesById, props.value]);
    const coaId = chart_of_accounts_1.chartOfAccountsUtils.getCoaId(props.value, props.allowBlank); // allow blank
    const coaNode = getCoaNode(coaId);
    const displayName = (0, helpers_1.getDisplayName)('', Boolean(props.longCats), coaNode);
    const [state, setState] = (0, react_1.useState)({
        tfValue: coaId === 'BLANK' ? '' : displayName,
        isTransfer: (0, helpers_1.isTransfer)(coaNode),
        query: null,
        showMenu: false,
        placeholder: null,
        inProgress: false,
        categoriesList: null,
    });
    const currentHover = (0, react_1.useRef)(null);
    const inputRef = (0, react_1.useRef)(null);
    const fieldRef = (0, react_1.useRef)(null);
    const handleRequestClose = () => {
        log.log('On Request Close...');
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showMenu: false })));
        if (props.menuClose) {
            props.menuClose();
        }
    };
    const menuOnChange = (item) => {
        if (item) {
            if (item.id === 'viewAll') {
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { query: null, showMenu: true })));
                return;
            }
            if (props.onChange) {
                if (props.returnSelectionMethod) {
                    props.onChange(item.coa);
                }
                else {
                    props.onChange(item.coa);
                }
            }
            handleRequestClose();
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { query: null })));
            if (props.menuClose) {
                props.menuClose();
            }
        }
    };
    const renderCOAMenuNode = (objCoaNode) => {
        if (!props.onlyL1 && objCoaNode.children) {
            const menuItems = objCoaNode.children.map((childNode) => (renderCOAMenuNode(childNode)));
            return { label: objCoaNode.name, value: objCoaNode, subMenu: menuItems };
        }
        if (objCoaNode.inList && (!props.filterFn || props.filterFn(objCoaNode.coa)) &&
            (0, helpers_1.coaIncludedInList)(objCoaNode.coa, categoriesById, accountsById, props.stType)) {
            let disabledCategory = false;
            if (objCoaNode.coa.type === 'ACCOUNT') {
                const hasWriteAccess = (0, utils_1.hasWriteAccessForAccountById)(accountsById, isEntitySharedUser, currentDataset, accountGroups, objCoaNode.coa.id);
                disabledCategory = !hasWriteAccess;
            }
            return { label: objCoaNode.name, value: objCoaNode, disabled: disabledCategory };
        }
        return { nop: true };
    };
    const buildMatchedString = (match, indexOfMatch) => {
        const parentSplit = match.indexOf(':');
        if (parentSplit !== -1 && parentSplit < indexOfMatch && state.query) { // need to grey out parent
            return (<QTypography_1.default>
          <Box_1.default component="span" sx={{ color: theme.palette.text.secondary }}>
            {match.slice(0, parentSplit)}
          </Box_1.default>
          <span>{match.slice(parentSplit, indexOfMatch)}</span>
          <Box_1.default component="span" sx={{ fontWeight: theme.typography.fontWeightMedium }}>
            {match.slice(indexOfMatch, indexOfMatch + state.query.length)}
          </Box_1.default>
          <span>{match.slice(indexOfMatch + state.query.length)}</span>
        </QTypography_1.default>);
        }
        const index = indexOfMatch === -1 ? 0 : indexOfMatch;
        let queryLength = 0;
        if (index && state.query) {
            queryLength = index + state.query.replace(':', ' : ').length;
        }
        // no parent so no greying out
        return (<QTypography_1.default>
        {match.slice(0, index)}
        <Box_1.default component="span" sx={{ fontWeight: theme.typography.fontWeightMedium }}>
          {match.slice(index, queryLength)}
        </Box_1.default>
        {match.slice(queryLength)}
      </QTypography_1.default>);
    };
    const filterOptions = (options, query) => {
        let items = [];
        const lowerCasedQuery = query === null || query === void 0 ? void 0 : query.toLowerCase();
        options.forEach((option) => {
            var _a;
            if (!option.nop && !option.isSubheader && option.value && option.value.fullPathName
                && option.label && ((_a = option.value.fullPathName) === null || _a === void 0 ? void 0 : _a.toLowerCase().indexOf(query === null || query === void 0 ? void 0 : query.toLowerCase())) !== -1
                && (!props.filterFn || props.filterFn(option.value.coa))) {
                const name = option.value.fullPathName.replace(':', ' : ');
                const boldIndex = name === null || name === void 0 ? void 0 : name.toLowerCase().indexOf(lowerCasedQuery);
                const { coa } = option.value;
                const shouldInclude = coa.type !== 'ACCOUNT' || (0, utils_1.hasWriteAccessForAccountById)(accountsById, isEntitySharedUser, currentDataset, accountGroups, coa.id);
                if (shouldInclude) {
                    items.push({
                        label: name,
                        customRender: buildMatchedString(name, boldIndex),
                        value: option.value,
                    });
                }
            }
            if (option.subMenu) {
                items = items.concat(filterOptions(option.subMenu, query));
            }
        });
        return items;
    };
    const dropDownClick = () => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { showMenu: !state.showMenu, query: null })));
        if (inputRef.current) {
            setTimeout(() => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 50);
        }
    };
    const handleInputFocus = ({ target }) => {
        target.focus();
        target.select(); // automatically highlights the input value
    };
    const handleQueryChange = ({ target }) => {
        setState((prevState) => (Object.assign(Object.assign({}, prevState), { query: target.value })));
    };
    const handleKeyDown = (event) => {
        var _a, _b, _c, _d, _e, _f, _g;
        const queryLength = ((_a = state.query) === null || _a === void 0 ? void 0 : _a.length) || 0;
        if (state.showMenu && event.key !== 'Tab' && event.key !== 'Enter') {
            event.stopPropagation();
        }
        else if (event.key !== 'Shift' && event.key !== 'Escape' && event.key !== 'Enter' && event.key !== 'Tab') {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { showMenu: !state.showMenu })));
        }
        else if (event.key === 'Enter' && (state.showMenu || state.query !== null)) {
            event.stopPropagation();
        }
        else if (event.key === 'Tab' && (state.showMenu || queryLength > 0) && currentHover) {
            if ((_b = currentHover.current) === null || _b === void 0 ? void 0 : _b.onSelect) {
                event.stopPropagation(); // if need to wait for category creation
                currentHover.current.onSelect();
            }
            else if (typeof ((_c = currentHover.current) === null || _c === void 0 ? void 0 : _c.value) === 'object' && ((_e = (_d = currentHover.current) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.coa) && props.onChange) {
                props.onChange((_g = (_f = currentHover.current) === null || _f === void 0 ? void 0 : _f.value) === null || _g === void 0 ? void 0 : _g.coa);
            }
        }
        else if (event.key === 'Escape') {
            handleRequestClose();
        }
    };
    const handleCurrentHover = (newCurrent) => {
        if (currentHover.current !== newCurrent) {
            currentHover.current = newCurrent;
        }
    };
    const handleNewCategoryClick = (newCatLabel, parentNode = null) => {
        const newCategoryClientId = (0, uuid_1.v4)().toUpperCase();
        let type = props.recommendedCategoryType || categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE;
        if (parentNode && parentNode.coa && parentNode.coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY && parentNode.coa.id) {
            const parentCategory = categoriesById.get(parentNode.coa.id);
            type = parentCategory && parentCategory.type ? parentCategory.type : categories_1.categoriesTypes.CategoryTypeEnum.EXPENSE;
        }
        if (assert(newCatLabel, `category name is required (name = '${newCatLabel}') #bug-trap`)) {
            const newCategory = categories_1.categoriesTypes.mkCategory({
                clientId: newCategoryClientId,
                // @ts-expect-error - FIXME: need to add null type as well for id in CategoryProps in companinon-app-components
                parentId: parentNode ? parentNode.id : '0',
                name: newCatLabel.trim(),
                type: type,
            });
            dispatch(categories_1.categoriesActions.createCategory(newCategory, { undo: { userMessage: 'Category created.' }, context: props === null || props === void 0 ? void 0 : props.context }));
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { newCategoryClientId, showMenu: false, query: null, placeholder: newCatLabel, inProgress: true })));
            setTimeout(() => {
                if (state.newCategoryClientId === newCategoryClientId && state.inProgress) {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { inProgress: false })));
                }
            }, 8000);
        }
    };
    const treeHasMainCategory = (name) => {
        var _a;
        return (_a = state.categoriesList) === null || _a === void 0 ? void 0 : _a.some((objCoaNode) => { var _a; return ((_a = objCoaNode.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().trim()) === (name === null || name === void 0 ? void 0 : name.toLowerCase().trim()); });
    };
    const flipIcon = state.showMenu || state.query !== null;
    const toolTipTitle = state.isTransfer ? `[${state.tfValue}]` : state.tfValue;
    const disableUnderlineObj = props.textFieldVariant === 'outlined' ? {} : { disableUnderline: props.disableUnderline };
    const popularCatsFiltered = props.filterFn ? popularCats.filter((x) => props.filterFn && props.filterFn(x.coa)) : popularCats;
    const prevProps = (0, react_use_1.usePrevious)(props);
    const prevCategoriesById = (0, react_use_1.usePrevious)(categoriesById);
    let menuItems = [];
    let selectedMenuItem;
    if (props.allowNone) {
        menuItems.push(renderCOAMenuNode(NONE_COA_NODE));
        menuItems.push({ nop: true, divider: true });
    }
    if (!state.query && popularCatsFiltered && popularCatsFiltered.size > 0) {
        if (props.numPopularCats && props.numPopularCats > 0) {
            menuItems.push({
                isSubheader: true,
                label: 'Most Used Categories',
            });
        }
        popularCatsFiltered.slice(0, props.numPopularCats).forEach((catRecord, index) => {
            menuItems.push({
                label: chart_of_accounts_1.chartOfAccountsSelectors.getCoaStringSelector(undefined, catRecord.coa, true),
                value: catRecord,
                subIndent: true,
                divider: index === (popularCatsFiltered.slice(0, props.numPopularCats).size - 1),
            });
        });
    }
    if (props.editable) {
        menuItems = menuItems.concat([{ isSubheader: true, label: 'All Categories' }]);
        // @ts-expect-error - FIXME: some type issue with concatinating menuItems
        menuItems = menuItems.concat(coaTree.map((objCoaNode) => (!props.filterFn || props.filterFn(objCoaNode.coa)) ? renderCOAMenuNode(objCoaNode) : null).toJS());
    }
    menuItems = menuItems.filter((x) => x !== null);
    if (state.query && state.query.trim()) {
        let addCatOption = props.createEnabled && !treeHasMainCategory(state.query);
        if (addCatOption) {
            addCatOption = {
                customRender: (<QTypography_1.default>
            Create
            <Box_1.default component="span" sx={{ fontWeight: theme.typography.fontWeightMedium }}>
              {` "${state.query}"`}
            </Box_1.default>
          </QTypography_1.default>),
                onSelect: noop_1.default,
                value: 'create-category-bucket',
                label: 'create-category',
                subMenu: [
                    {
                        label: 'Main Category',
                        value: 'create-parent-category',
                        onSelect: () => handleNewCategoryClick(state.query || ''),
                    },
                    {
                        label: 'Subcategory of',
                        value: 'create-child-category',
                        onSelect: noop_1.default,
                        subMenu: coaTree
                            .filter((objCoaNode) => (objCoaNode === null || objCoaNode === void 0 ? void 0 : objCoaNode.coa) && (objCoaNode.coa.type === chart_of_accounts_1.chartOfAccountsTypes.CoaTypeEnum.CATEGORY))
                            .map((objCoaNode) => {
                            const menuNode = renderCOAMenuNode(objCoaNode);
                            return Object.assign(Object.assign({}, menuNode), { subMenu: null, onSelect: () => handleNewCategoryClick(state.query || '', menuNode.value) });
                        }),
                    },
                ],
            };
        }
        menuItems = filterOptions(menuItems, state.query.trim());
        if (menuItems && menuItems.length) {
            selectedMenuItem = menuItems[0];
        }
        else if (addCatOption) {
            selectedMenuItem = addCatOption;
        }
        if (addCatOption) {
            menuItems.unshift(addCatOption);
        }
        menuItems.push({
            label: 'See All Categories',
            value: 'see-all',
            onSelect: () => {
                setState((prevState) => (Object.assign(Object.assign({}, prevState), { query: null })));
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.select();
                }
            },
        });
    }
    (0, react_1.useEffect)(() => {
        if (props.initialFocus && inputRef.current) {
            inputRef.current.focus();
        }
        if (props.openMenu) {
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { showMenu: true })));
        }
        if (categoriesById) {
            // @ts-expect-error - FIXME: issue with categoriesList
            setState((prevState) => (Object.assign(Object.assign({}, prevState), { categoriesList: categoriesById.toList() })));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, react_1.useEffect)(() => {
        if (!prevProps) {
            return;
        }
        if (props.coaNodesById) {
            if (props.value !== prevProps.value
                || props.coaNodesById !== prevProps.coaNodesById
                || props.longCats !== prevProps.longCats) {
                // TODO: if coaNode cannot be found, set it to uncategorized coaNode
                if (coaNode) {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { isTransfer: (0, helpers_1.isTransfer)(coaNode), tfValue: displayName })));
                }
                else {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { isTransfer: false, tfValue: '' })));
                }
                if (!props.value ||
                    (inputRef && (0, utils_2.safeRefIn)(props, ['value', 'id']) !== (0, utils_2.safeRefIn)(prevProps, ['value', 'id']))) {
                    if (inputRef.current && prevProps.autoFocus) {
                        if (react_device_detect_1.isTablet) {
                            setTimeout(() => {
                                if (inputRef.current) {
                                    inputRef.current.focus();
                                    inputRef.current.select();
                                }
                            }, 250);
                        }
                        else {
                            inputRef.current.focus();
                            inputRef.current.select();
                        }
                    }
                }
            }
        }
    }, [props, prevProps, coaNode, displayName]);
    (0, react_1.useEffect)(() => {
        if (prevCategoriesById !== categoriesById && state.newCategoryClientId) {
            const newCategoryCreated = categoriesById.find((category) => category.clientId === state.newCategoryClientId);
            if (newCategoryCreated) {
                const newNode = props.coaNodesById && props.coaNodesById.get(newCategoryCreated.id);
                const newCOA = newNode && newNode.coa;
                if (props.onChange && newCOA) {
                    props.onChange(newCOA);
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { newCategoryClientId: undefined, inProgress: false })));
                }
            }
        }
    }, [state.newCategoryClientId, prevCategoriesById, categoriesById, props]);
    if (props.editable) {
        return (<Box_1.default id={props.id ? `${props.id}-root` : 'category-root'} ref={fieldRef} sx={Object.assign(Object.assign({}, props.style), { width: props.width })} className={(_a = props.classes) === null || _a === void 0 ? void 0 : _a.root}>
        <TextField_1.default disabled={state.inProgress} onClick={dropDownClick} {...props.textFieldProps} variant={props.textFieldVariant} className={props.className || ''} label={props.label} value={state.query !== null ? state.query : state.placeholder || state.tfValue || ''} onChange={handleQueryChange} onKeyDown={handleKeyDown} onFocus={handleInputFocus} onBlur={state.showMenu ? undefined : props.onBlur} autoFocus={props.autoFocus} sx={{ width: '100%' }} error={props.error} name={props.name} margin={props.margin} autoComplete="off" InputProps={Object.assign(Object.assign(Object.assign({}, props.InputProps), disableUnderlineObj), { id: props.id ? `${props.id}-input` : 'category-input', endAdornment: (<>
                {state.inProgress && // dont take up precious space for a 5% use case (on create cat)
                        <CircularProgress_1.default size={16} sx={{ visibility: state.inProgress ? 'visible' : 'hidden' }}/>}
                {props.error && <Error_1.default sx={{ color: theme.palette.number.negative }}/>}
                <QIconButton_1.default id={props.id ? `${props.id}-button` : 'category-button'} disabled={state.inProgress} sx={{ color: theme.palette.grey.level6, cursor: 'pointer', fontSize: '23px', opacity: flipIcon && 1 }} aria-label="Open Category List" focusRipple IconComponent={flipIcon ? ExpandLessRounded_1.default : ExpandMoreRounded_1.default} onClick={dropDownClick} size="small-no-padding" TooltipProps={{ enterDelay: 10 }} tabIndex={-1}/>
              </>), sx: Object.assign({ paddingTop: 0, paddingBottom: 0, height: props.textFieldVariant === 'outlined' ? 'auto' : inputHeight, lineHeight: '22px', fontSize: props.fontSize, color: (state.query && state.query !== state.tfValue) || (state.placeholder && state.placeholder !== state.tfValue) ?
                        theme.palette.text.secondary : undefined }, (props.InputProps ? props.InputProps.style : {})) })} 
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{
                className: props.inputStyle || '',
                style: { height: 23 },
            }} inputRef={props.inputRef ? props.inputRef : inputRef}/>
        <Box_1.default sx={{ margin: 'auto' }}>
          {fieldRef.current && (<NestedQMenu_1.default anchorEl={fieldRef.current} header={props.header} name="catmenu" options={menuItems} selectedOption={selectedMenuItem} onChange={menuOnChange} open={state.showMenu || state.query !== null} onClose={() => {
                    setState((prevState) => (Object.assign(Object.assign({}, prevState), { query: null })));
                    handleRequestClose();
                    if (props.onBlur && props.blurOnMenuClose) {
                        props.onBlur({ relatedTarget: 'categoryfield' });
                    }
                }} currentHover={handleCurrentHover}/>)}
        </Box_1.default>
      </Box_1.default>);
    }
    return (<QTip_1.default wrapOnly title={props.tooltip ? toolTipTitle : null}>
      <QTypography_1.default variant={props.variant} clickable={props.clickable} className={props.classNameWhenNotEditable}>
        {state.isTransfer ? `[${state.tfValue}]` : state.tfValue}
      </QTypography_1.default>
    </QTip_1.default>);
};
CategoryFieldEditable.defaultProps = {
    variant: 'body2',
    transferOnly: false,
    numPopularCats: 5,
    width: '100%',
    textFieldVariant: 'standard',
    context: '',
};
exports.default = (0, react_1.memo)(CategoryFieldEditable);
